import React from 'react';
import PropTypes from 'prop-types';

const OptionsIcon = ({
  fill, width, height,
}) => (
  <svg width={width} height={height} viewBox="0 0 4 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4C3.10275 4 4 3.10275 4 2C4 0.89725 3.10275 0 2 0C0.89725 0 0 0.89725 0 2C0 3.10275 0.89725 4 2 4Z" fill={fill} />
    <path d="M2 15C0.89725 15 0 15.8973 0 17C0 18.1027 0.89725 19 2 19C3.10275 19 4 18.1027 4 17C4 15.8973 3.10275 15 2 15Z" fill={fill} />
    <path d="M2 7.5C0.89725 7.5 0 8.39725 0 9.5C0 10.6027 0.89725 11.5 2 11.5C3.10275 11.5 4 10.6027 4 9.5C4 8.39725 3.10275 7.5 2 7.5Z" fill={fill} />
  </svg>
);

export default OptionsIcon;

OptionsIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

OptionsIcon.defaultProps = {
  fill: '#BABCC0',
  width: 4,
  height: 19,
};
